import { useDispatch } from 'react-redux';

export default function useStoreCarPlanList() {
    const dispatch = useDispatch();

    const executor = (carQuoteList) => {
        return dispatch({
            type: 'SET_CAR_QUOTE_LIST',
            payload: carQuoteList,
        });
    };

    return executor;
};